import React, { useEffect, useState } from "react";
import { useHookstate } from "@hookstate/core";
import EditIcon from "assets/svgIcons/EditSqrIcon";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import SixDots from "assets/svgIcons/SixDot";
import TickIcon from "assets/svgIcons/TickIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import {
  MESSAGE_VDU_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
} from "../../../../globalStore/globalStore";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import CheckIcon from "assets/svgIcons/CheckIcon";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import { TableContainer } from "pages/Messages/Settings/SettingsStyled";
import { StyledTable } from "assets/css/globle";
import CloseIcon from "assets/svgIcons/CloseIcon";
import { SelectTagCar } from "../../../../commonComponents/SideNav/subSectionNav/Map/MapStyled";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { PopUpContainer } from "assets/css/globle";
import RadioCheckIcon from "assets/svgIcons/RadioCheckedIcon";
import RadioUncheckIcon from "assets/svgIcons/RadioUncheckIcon";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { IconButton, Tooltip } from "@mui/material";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import { EditMsgModalWrapper } from "pages/Messages/Settings/SettingsStyled";
import { isUserBasic, isUserReadOnly } from "constant";

const SettingsTable = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { globalMessageBoxOpenClose, setSave } = useHookstate(
    MESSAGE_VDU_GLOBAL_STATE
  );
  // states
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "calc(100% - 40px)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };
  const [storeId, setStoreId] = useState();
  const [open, setOpen] = useState(false);
  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [modalOpenar, setModalOpenar] = useState(false);
  const [text, setText] = useState("");
  const [Id, setId] = useState(0);
  const [priority, setPriority] = useState(false);
  const [okResponse, setOkResponse] = useState(false);
  const [yesNoResponse, setYesNoResponse] = useState(false);
  const [noneResponse, setNoneResponse] = useState(false);
  const [alertResponse, setAlertResponse] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  // handel edit button.

  useEffect(() => {
    dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
  }, [siteId.get()]);

  const handleEditButton = (Id, Body, Priority, Response) => {
    globalMessageBoxOpenClose.set(false);
    let payload = {
      Id: Id,
      Body: Body,
      FromGroupId: 0,
      ToGroupId: 0,
      Audible: false,
      Priority: Priority,
      YesNoResponse: Response,
      OkResponse: false,
    };
    dispatch(
      COMMON_SERVICES.deleteMessagesSettingServices(payload, siteId.get())
    ).then(() => {
      dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
      globalMessageBoxOpenClose.set(false);
    });
  };
  // handel delete butoon
  const handelDeleteButton = (Id) => {
    dispatch(
      COMMON_SERVICES.deleteMessagesSettingServices(Id, siteId.get())
    ).then(() => {
      dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
    });
    setOpen(false);
  };

  const handelDeleteButtonFunction = (Id) => {
    setOpen(true);
    setStoreId(Id);
    // handelDeleteButton(Id);
  };

  const handelSaveButtonTable = (
    Id,
    text,
    Priority,
    Response,
    getYesNoResponse,
    getAlertResponse
  ) => {
    if (text.length > 0) {
      let payload = {
        Id: Id,
        Body: text,
        FromGroupId: 0,
        ToGroupId: 0,
        Audible: getAlertResponse,
        Priority: Priority,
        YesNoResponse: getYesNoResponse,
        OkResponse: Response,
      };
      dispatch(
        COMMON_SERVICES.putMessagesSettingServices2(payload, siteId.get())
      ).then(() => {
        dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
      });
      setText(null);
      setOkResponse(false);
      setPriority(false);
      setOpenMessageBox(false);
      setSave.set(false);
    }
  };

  const dispatch = useDispatch();

  const { cannedMessagesData, getUserRole } =
    useSelector((state) => state.commonReducers) || [];
  const [users, setUsers] = useState(cannedMessagesData);

  useEffect(() => {
    setUsers(cannedMessagesData);
  }, [cannedMessagesData]);

  function responseString(message) {
    if (message.YesNoResponse) return <h4>{t("Yes/No")}</h4>;
    if (message.OkResponse) return <h4>{t("Ok")}</h4>;
    return <h4>-</h4>;
  }

  const handleDragEnd = (e) => {
    if (!e.destination) return;
    // Create a copy of the users array
    let tempData = Array.from(users);
    // Remove the dragged item from the source index
    let [source_data] = tempData.splice(e.source.index, 1);
    // Insert the dragged item at the destination index
    tempData.splice(e.destination.index, 0, source_data);
    // Update the state with the new user order
    setUsers(tempData);
    dispatch(
      COMMON_SERVICES.putMessagesSettingServices3(tempData, siteId.get())
    );
  };

  const showModalBox = () => {
    return (
      <Modal
        open={modalOpenar}
        onClose={() => setModalOpenar(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Discard_changes")}?</p>
            <div className="action-btn">
              <button
                onClick={() => {
                  setModalOpenar(false);
                  setSave.set(false);
                  setOpenMessageBox(false);
                }}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button onClick={() => setModalOpenar(false)}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  return (
    <TableContainer>
      {showModalBox()}
      <StyledTable>
        <DragDropContext onDragEnd={handleDragEnd}>
          <table className="">
            <tr className="table-head">
              <th className="display"></th>
              <th>{t("Text")}</th>
              <th className="text-center">{t("Priority")}</th>
              <th>{t("Alert")}</th>
              <th>{t("Response")}</th>
              <th className="">{t("Action")}</th>
            </tr>
            <Droppable droppableId="droppable-1">
              {(provider) => (
                <tbody ref={provider.innerRef} {...provider.droppableProps}>
                  {users != undefined && users?.length > 0 ? (
                    users?.map((item, index) => (
                      <Draggable
                        key={item?.Id}
                        draggableId={item?.Id.toString()}
                        index={index}
                      >
                        {(provider) => (
                          <tr
                            {...provider.draggableProps}
                            ref={provider.innerRef}
                            className="body"
                            key={item?.Id}
                          >
                            <td
                              {...provider.dragHandleProps}
                              className="display"
                            >
                              <div style={{ width: "40px" }}>
                                <SixDots />
                              </div>
                            </td>
                            <td>{item.Body}</td>
                            <td className="text-center">
                              {item.Priority ? <TickIcon /> : null}
                            </td>
                            <td>{item.Audible ? <TickIcon /> : null}</td>

                            <td>
                              {responseString(item)}                           
                            </td>

                            <td className="">
                              <div className="action-btn">
                                <Tooltip title={t("Edit")} arrow>
                                  <IconButton
                                    disabled={
                                      isUserBasic(
                                        getUserRole && getUserRole?.Role
                                      ) ||
                                      isUserReadOnly(
                                        getUserRole && getUserRole?.Role
                                      )
                                    }
                                    onClick={() => {
                                      let getNoneRes =
                                        !item?.OkResponse &&
                                        !item?.YesNoResponse;
                                      setOpenMessageBox(true);
                                      setId(item?.Id);
                                      setText(item?.Body);
                                      setOkResponse(item?.OkResponse);
                                      setYesNoResponse(item?.YesNoResponse);
                                      setPriority(item?.Priority);
                                      setNoneResponse(getNoneRes);
                                      setAlertResponse(item?.Audible);
                                      setSave.set(false);
                                    }}
                                  >
                                    <EditIcon
                                      color="#0009"
                                      width={20.19}
                                      height={20.19}
                                    />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={t("Delete")} arrow>
                                  <IconButton
                                    disabled={
                                      isUserBasic(
                                        getUserRole && getUserRole?.Role
                                      ) ||
                                      isUserReadOnly(
                                        getUserRole && getUserRole?.Role
                                      )
                                    }
                                    onClick={() =>
                                      handelDeleteButtonFunction(item?.Id)
                                    }
                                  >
                                    <DeleteIcon
                                      color="#FA3C30"
                                      width={18.19}
                                      height={20.19}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))
                  ) : (
                    <tr style={{ textAlign: "center", width: "100%" }}>
                      <td colSpan={5}>
                        <h3>{t("No_data")}</h3>
                      </td>
                    </tr>
                  )}
                  {provider.placeholder}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </StyledTable>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Delete_this_message")}?</p>
            <div className="action-btn">
              <button
                onClick={() => {
                  handelDeleteButton(storeId);
                }}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button onClick={() => setOpen(false)}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      {/*#################################################################### Edit message modal open ####################################*/}

      {openMessageBox ? (
        <EditMsgModalWrapper>
          <SelectTagCar className="edit-msg-window">
            <div className="inner-wrapper">
              <div className="box-heading">
                <h5>{t("Edit_message")}</h5>
                <CloseIcon
                  onClick={() => {
                    setSave.get() === true
                      ? setModalOpenar(true)
                      : setOpenMessageBox(false);
                  }}
                  width={22}
                  height={22}
                />
              </div>
              <div className="text-area">
                <textarea
                  maxLength={182}
                  id="w3review"
                  name="w3review"
                  rows="4"
                  placeholder={t("Type_your_message")}
                  value={text}
                  onChange={(e) => {
                    if (e.target.value?.length) {
                      setSave.set(true);
                      setText(e.target.value);
                    } else {
                      setSave.set(false);
                      setText("");
                    }
                  }}
                ></textarea>

                <div className="checkbox-wrapper">
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={priority}
                          onChange={(e) => {
                            setSave.set(true);
                            setPriority(e.target.checked);
                          }}
                          inputProps={{ "aria-label": "controlled" }}
                          icon={<UnCheckIcon width={15} height={15} />}
                          checkedIcon={<CheckIcon width={15} height={15} />}
                        />
                      }
                      label={t("Priority")}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={alertResponse}
                          onChange={(e) => {
                            setSave.set(true);
                            setAlertResponse(e.target.checked);
                          }}
                          inputProps={{ "aria-label": "controlled" }}
                          icon={<UnCheckIcon width={15} height={15} />}
                          checkedIcon={<CheckIcon width={15} height={15} />}
                        />
                      }
                      label={t("Alert")}
                    />
                  </FormGroup>
                </div>
                <div className="response-section">
                  <p>{t("Response")}</p>
                  <div>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel
                        value="noneResponse"
                        control={
                          <Radio
                            icon={<RadioUncheckIcon width={15} height={15} />}
                            checkedIcon={
                              <RadioCheckIcon width={15} height={15} />
                            }
                            checked={noneResponse}
                            onChange={(e) => {
                              setSave.set(true);
                              setNoneResponse(e.target.checked);
                              setOkResponse(!e.target.checked);
                              setYesNoResponse(!e.target.checked);
                            }}
                          />
                        }
                        label={t("None")}
                      />
                      <FormControlLabel
                        value="okResponse"
                        control={
                          <Radio
                            icon={<RadioUncheckIcon width={15} height={15} />}
                            checkedIcon={
                              <RadioCheckIcon width={15} height={15} />
                            }
                            checked={okResponse}
                            onChange={(e) => {
                              setSave.set(true);
                              setOkResponse(e.target.checked);
                              setNoneResponse(!e.target.checked);
                              setYesNoResponse(!e.target.checked);
                            }}
                          />
                        }
                        label={t("Ok")}
                      />
                      <FormControlLabel
                        value="yesNoResponse"
                        control={
                          <Radio
                            icon={<RadioUncheckIcon width={15} height={15} />}
                            checkedIcon={
                              <RadioCheckIcon width={15} height={15} />
                            }
                            checked={yesNoResponse}
                            onChange={(e) => {
                              setSave.set(true);
                              setYesNoResponse(e.target.checked);
                              setNoneResponse(!e.target.checked);
                              setOkResponse(!e.target.checked);
                            }}
                          />
                        }
                        label={t("Yes/No")}
                      />
                    </RadioGroup>
                  </div>
                </div>
                <div className="action-wrapper">
                  <button
                    // className="send-btn"
                    style={{
                      pointerEvents: setSave.get() === true ? "auto" : "none",
                    }}
                    className={
                      setSave.get() === true
                        ? "active send-btn"
                        : "disabled send-btn"
                    }
                    onClick={() =>
                      handelSaveButtonTable(
                        Id,
                        text,
                        priority,
                        okResponse,
                        yesNoResponse,
                        alertResponse
                      )
                    }
                  >
                    {t("Save")}
                  </button>
                  <button
                    className="send-btn"
                    onClick={() => {
                      setText("");
                      setSave.set(false);
                    }}
                  >
                    {t("Clear")}
                  </button>
                </div>
              </div>
            </div>
          </SelectTagCar>
        </EditMsgModalWrapper>
      ) : (
        <> </>
      )}
      {/* ################################################################### edit message modal close #####################################3 */}
    </TableContainer>
  );
};

export default SettingsTable;
